<template>
    <div class="table_wrap">
        <div class="c_table_wrap table_search_wrap">
            <div class="filter-select-div el-filter-date mb11">
                <span class="filter-select-span mr24">등록일</span>
                <span class="el-date-icon mr2" :class="checkFilterData() ? 'iconMove' : ''">
                        <span class="el-date-icon-img"></span>
                        <el-date-picker
                                v-model="filterDate"
                                type="daterange"
                                range-separator=""
                                value-format="yyyy-MM-dd"
                                start-placeholder="시작날짜"
                                end-placeholder="끝 날짜"
                                @change="setFilterFunc('cr', filterDate)"
                                class="el-date-common"
                                prefix-icon=" "
                                clear-icon="el-icon-circle-close el-clear-icon"
                        ></el-date-picker>
                    </span>
            </div>
            <div class="filter-select-div el-filter-date mb11">
                <span class="filter-select-span mr24 ml20">시작일시</span>
                <span class="el-date-icon mr2" :class="checkFilterData() ? 'iconMove' : ''">
                        <span class="el-date-icon-img"></span>
                        <el-date-picker
                            v-model="filterStartDate"
                            type="daterange"
                            range-separator=""
                            value-format="yyyy-MM-dd"
                            start-placeholder="시작날짜"
                            end-placeholder="끝 날짜"
                            @change="setFilterFunc('sl', filterStartDate)"
                            class="el-date-common"
                            prefix-icon=" "
                            clear-icon="el-icon-circle-close el-clear-icon"
                        ></el-date-picker>
                    </span>
            </div>
            <br/>
            <div class="filter-select-div el-filter-date ">
                <span class="filter-select-span mr24">상태</span>
                <span class="filter-select-span mr24">
                    <el-select class="select" v-model="filterStatus" @change="setFilterFunc('st', filterStatus)">
                        <el-option value="" label="전체"></el-option>
                        <el-option :value="1" label="진행중"></el-option>
                        <el-option :value="2" label="완료"></el-option>
                        <el-option :value="3" label="취소"></el-option>
                        <el-option :value="4" label="시작예정"></el-option>
                    </el-select>
                </span>
            </div>

            <div class="filter-show-count">
                <el-select v-model="size" @change="changePage('size', size)">
                    <el-option v-for="(sizeData) in sizeList" :key="`size${sizeData}`" :value="sizeData"
                               :label="`${sizeData}개씩 보기`"></el-option>
                </el-select>
            </div>
        </div>
    </div>
</template>

<script>
    import liveklassUtil from "@/components/liveklass/liveklassUtil";

    const {filterConfig} = liveklassUtil;
    export default {
        name: "LiveKlassFilterStreamingLayout",
        mixins: [liveklassUtil],
        components: {},
        inject: ['setPage', 'setFilter'],
        provide() {
            return {}
        },
        props: {
            filterData: {
                default: () => {
                    return {}
                }
            },
            paginationData: {
                default: () => {
                    return {total: 0, page: 0, size: 0,}
                }
            },

        },
        data() {
            return {
                filterDate: [],
                filterStartDate: [],
                filterStatus: '',

                filterSort:'',
                size: 10,
                sizeList: [10, 30, 50],

                selectSort: false,
            }
        },
        created() {
        },
        mounted() {
            this.setterFilterDataInData();

        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {},
        methods: {
            setterFilterDataInData() {
                let classnames = Object.keys(this.filterData);
                classnames.forEach(classname => {
                    let obj = this.filterData[classname];
                    let type = filterConfig[obj.key].type;
                    if (this.hasOwnProperty(classname)) {
                        // this[classname] =
                        if (type == 'query') {
                            this[classname] = obj.query;
                            if(this.hasOwnProperty(classname+'Option')) {
                                this[classname+'Option'] = obj.key;
                            }
                        } else if (type === 'between') {
                            this[classname] = [obj.start, obj.end];
                        } else if (type === 'match') {
                            if (isNaN(obj.value)) {
                                this[classname] = obj.value;
                            } else {
                                this[classname] = Number(obj.value);
                            }

                        }

                    }
                })
                this.size = this.paginationData.size;
            },
            setFilterFunc(key, value) {
                this.setFilter(key, value);
            },

            changePage(key, value) {
                this.setPage(key, value);
                this.setPage('page', 1);
            },
            checkFilterData() {
                return this.filterDate != null && this.filterDate.length > 0;
            },
            changeSort(sort) {
                sort ? this.filterSort = 'desc' : this.filterSort='asc'
                this.setFilter('obs', this.filterSort)
            },
        },
        watch: {},
    }
</script>

<style lang="scss">


</style>
